// Audit Opinion on the Signed Financial Statements — the fixed option list,
// shared by the workflow pages (New / Detail / Modify), the Management record
// form and the server's validation (CommonJS for the same reason as
// qcQuestions.js: the server requires it too).
//
// The value stored is the label itself (`wf_fs_requests.audit_opinion`,
// `fs_records.audit_opinion`); the CHECK constraint in migration 0224 lists
// the same five values. Mandatory on every submission and on Management
// entries; records created by the data-import tool may leave it NULL.

const AUDIT_OPINIONS = [
  'Unmodified Opinion',
  'Qualified Opinion',
  'Adverse Opinion',
  'Disclaimer of Opinion',
  'Not Applicable',
];

const isAuditOpinion = (v) => AUDIT_OPINIONS.includes(v);

module.exports = { AUDIT_OPINIONS, isAuditOpinion };
